import React from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { SearchEventContainer } from "../../../../mypage/scheduler/component/styled/scheduler";
import ScheduleTable from "../../../../../common/scheduleTable";

const Schedule = ({ data, isSearch, searchWord }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleClickEvent = (event) => {
    navigate(`/mypage/detailEvent/${event.scheduleNo}`, {
      state: {
        path: `/group/${id}/search`,
        search: searchWord,
        tab: 3,
      },
    });
  };

  const formatNumber = (num) => {
    return num?.toLocaleString("ko-KR") ?? "0";
  };

  return (
    <SearchEventContainer>
      {isSearch && (
        <div className="searchContaier" style={{ height: "auto" }}>
          <div className="label">
            {data && data.length > 0 && (
              <span>
                검색 결과<strong>{formatNumber(data.length)}</strong>개
              </span>
            )}
          </div>
          {data && data.length > 0 ? (
            <ScheduleTable data={data} onClickEvent={handleClickEvent} />
          ) : (
            <div className="not">일정이 존재하지 않습니다.</div>
          )}
        </div>
      )}
    </SearchEventContainer>
  );
};

export default Schedule;
